
export interface JumpAuthRequestBody {
    surveyId: string;
}

export interface JumpAuthResponse {
    jst: string;
    jpt: string;
    projectId: string;
}

export interface JumpProjectAppsResponse {
    id: string;
    apiOnly: boolean;
    noDemo?: boolean;
    iconLocation: number;
    internalApp: boolean;
    version: number;
    created: Date;
    updated: Date;
    lastModifiedBy: string;
    name: string;
    url: string;
    settingsUrl?: string;
    description?: string;
    permissionDescription?: string;
    icon: string;
    tokenUrl: string;
    disabled: boolean;
    appDisabled: boolean;
}

export interface JumpAppWrapper {
    appName: string;
    appUrl: string;
}